import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const apiUrlSectores = process.env.REACT_APP_API_SECTORES;

function AbmSectores() {
    const [sectores, setSectores] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [showModal, setShowModal] = useState(false)
    const [sectorAEliminar, setSectorAEliminar] = useState(null)
    const navigate = useNavigate();

    useEffect(() => {
        getSectores()
    }, [])

    const getSectores = async () => {
        try {
            setIsLoading(true)
            const res = await axios.get(apiUrlSectores)
            setSectores(res.data)
        } catch (error) {
            console.error("Error al intentar mostrar los sectores", error)
            alert('❌ Error al cargar los sectores')
        } finally {
            setIsLoading(false)
        }
    };

    const confirmarEliminacion = (sector) => {
        setSectorAEliminar(sector)
        setShowModal(true)
    }

    const deleteSectores = async () => {
        try {
            await axios.delete(`${apiUrlSectores}${sectorAEliminar.id_sector}`);
            alert('✅ Sector eliminado correctamente')
            setShowModal(false)
            setSectorAEliminar(null)
            getSectores();
        } catch (error) {
            console.error("Error al intentar eliminar sector;", error);
            alert('❌ Error al eliminar el sector: ' + (error.response?.data?.error || error.message));
        }
    };

    if (isLoading) {
        return (
            <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-100 flex items-center justify-center">
                <div className="bg-white p-8 rounded-2xl shadow-xl">
                    <div className="flex items-center gap-4">
                        <svg className="animate-spin h-8 w-8 text-green-600" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" fill="none" />
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
                        </svg>
                        <span className="text-lg font-semibold text-gray-700">Cargando sectores...</span>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-gradient-to-br from-green-50 via-emerald-50 to-teal-100 py-8 px-4">
            <div className="max-w-6xl mx-auto">
                {/* Header */}
                <div className="bg-white rounded-2xl shadow-xl p-6 mb-6 border-b-4 border-green-500">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="bg-gradient-to-br from-green-500 to-emerald-600 p-4 rounded-xl shadow-lg">
                                <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                </svg>
                            </div>
                            <div>
                                <h1 className="text-3xl font-bold text-gray-800">Gestión de Sectores</h1>
                                <p className="text-gray-600 mt-1">Administra los sectores y departamentos</p>
                            </div>
                        </div>
                        <button
                            onClick={() => navigate('/admin/CreateSection')}
                            className="bg-gradient-to-r from-green-600 to-emerald-600 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-green-700 hover:to-emerald-700 transform hover:scale-105 transition-all flex items-center gap-2"
                        >
                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                            </svg>
                            Nuevo Sector
                        </button>
                    </div>
                </div>

                {/* Tabla */}
                <div className="bg-white rounded-2xl shadow-xl overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full">
                            <thead className="bg-gradient-to-r from-green-600 to-emerald-600 text-white">
                                <tr>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Sector</th>
                                    <th className="px-6 py-4 text-left text-sm font-bold uppercase tracking-wider">Sede</th>
                                    <th className="px-6 py-4 text-center text-sm font-bold uppercase tracking-wider w-40">Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {sectores.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="px-6 py-12 text-center text-gray-500">
                                            <div className="flex flex-col items-center gap-3">
                                                <svg className="w-16 h-16 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                                                </svg>
                                                <p className="text-lg font-semibold">No hay sectores registrados</p>
                                                <p className="text-sm">Crea un nuevo sector para comenzar</p>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    sectores.map((sector) => (
                                        <tr key={sector.id_sectores || sector.id_sector} className="hover:bg-green-50 transition-colors">
                                            <td className="px-6 py-4">
                                                <span className="font-bold text-gray-800">{sector.sector}</span>
                                            </td>
                                            <td className="px-6 py-4 text-gray-600">
                                                <span className="inline-flex items-center gap-2">
                                                    <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                                    </svg>
                                                    {sector.sede?.nombre_sede || 'Sin sede asignada'}
                                                </span>
                                            </td>
                                            <td className="px-6 py-4">
                                                <div className="flex items-center justify-center gap-2">
                                                    <button
                                                        onClick={() => navigate(`/admin/EditSection/${sector.id_sector}`)}
                                                        className="bg-gradient-to-r from-blue-500 to-cyan-600 text-white p-2 rounded-lg hover:from-blue-600 hover:to-cyan-700 transition-all transform hover:scale-110 shadow-md"
                                                        title="Editar"
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                        </svg>
                                                    </button>
                                                    <button
                                                        onClick={() => confirmarEliminacion(sector)}
                                                        className="bg-gradient-to-r from-red-500 to-rose-600 text-white p-2 rounded-lg hover:from-red-600 hover:to-rose-700 transition-all transform hover:scale-110 shadow-md"
                                                        title="Eliminar"
                                                    >
                                                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Info card */}
                <div className="mt-6 bg-green-50 border-l-4 border-green-500 p-4 rounded-r-lg shadow-md">
                    <div className="flex items-start gap-3">
                        <svg className="w-6 h-6 text-green-600 flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                        </svg>
                        <div>
                            <p className="text-sm font-semibold text-green-900">Organización por Sectores</p>
                            <p className="text-sm text-green-700 mt-1">
                                Los sectores permiten organizar a los usuarios dentro de cada sede según su departamento o área de trabajo.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal de confirmación */}
            {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-6 transform transition-all">
                        <div className="flex items-center gap-4 mb-4">
                            <div className="bg-red-100 p-3 rounded-full">
                                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-gray-800">Confirmar Eliminación</h3>
                                <p className="text-sm text-gray-600">Esta acción no se puede deshacer</p>
                            </div>
                        </div>
                        <p className="text-gray-700 mb-2">
                            ¿Estás seguro que deseas eliminar el sector <span className="font-bold text-green-600">{sectorAEliminar?.sector}</span>?
                        </p>
                        <div className="bg-yellow-50 border-l-4 border-yellow-500 p-3 rounded-r-lg mb-6">
                            <p className="text-sm text-yellow-800 font-semibold">
                                ⚠️ Los usuarios asociados a este sector quedarán sin sector asignado
                            </p>
                        </div>
                        <div className="flex gap-3">
                            <button
                                onClick={deleteSectores}
                                className="flex-1 bg-gradient-to-r from-red-600 to-rose-600 text-white font-bold py-3 px-6 rounded-lg hover:from-red-700 hover:to-rose-700 transition-all transform hover:scale-105"
                            >
                                Eliminar
                            </button>
                            <button
                                onClick={() => { setShowModal(false); setSectorAEliminar(null); }}
                                className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-bold py-3 px-6 rounded-lg transition-all transform hover:scale-105"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default AbmSectores;